import { connect } from 'react-redux';

import { getVisibleElement } from 'selectors/drawer';
import { getContentErrorSelector, getIsAuthenticated } from 'selectors/session';
import ContentLayout from './index';

const mapStateToProps = (state) => ({
    location: state.router.location,
    smallDrawerType: (getVisibleElement(state.smallDrawer) || {}).key,
    hasError: !!getContentErrorSelector(state),
    isAuthenticated: getIsAuthenticated(state),
});

export default connect(
    mapStateToProps,
    null
)(ContentLayout);
